<template>
	<Popup
		v-model="selfDisplay"
		title="新增"
		confirmBtnText="新增"
		@confirmClick="handleAddClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>序号</span>
				<el-input v-model="order" placeholder="序号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="orderTip"><i class="b_icon"></i>请输入整数</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>内容类型</span>
				<el-select v-model="type" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in iAssistantScienceType" :key="v.id" :value="v.id" :label="v.label"></el-option>
				</el-select>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>分类</span>
				<el-select v-model="sort" placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in sortList" :key="v.id" :value="v.id" :label="v.label"></el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="sortTip"><i class="b_icon"></i>请选择分类</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>标题</span>
				<el-input v-model="title" placeholder="标题"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="titleTip"><i class="b_icon"></i>请输入标题</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>封页图</span>
				<div v-if="!cover" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" accept="image/*" @change="handleCoverUpload"/>
					<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
				</div>
				<div v-if="cover" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="cover" alt="" style="">
					<i @click="handleCoverDelete"></i>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="coverTip"><i class="b_icon"></i>请上传图片</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>内容</span>
				<editor v-model="content"></editor>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="contentTip"><i class="b_icon"></i>请编辑内容</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../api/index.js';
	import BaseMethods from '../../../../../../assets/js/base.js';
	import { mapState } from 'vuex';
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				sortList: [],
				
				order: 1,
				type: 2,
				sort: '',
				title: '',
				cover: '',
				content: '',
				orderTip: false,
				sortTip: false,
				titleTip: false,
				coverTip: false,
				contentTip: false
			}
		},
		computed: {
			...mapState([
				'iAssistantScienceType'
			])
		},
		methods: {
			// 点击新增
			handleAddClick() {
				if (!this.positiveReg.test(this.order)) {
					this.orderTip = true;
					return false;
				} else {
					this.orderTip = false;
				}
				if (!this.sort) {
					this.sortTip = true;
					return false;
				} else {
					this.sortTip = false;
				}
				if (!this.title.trim()) {
					this.titleTip = true;
					return false;
				} else {
					this.titleTip = false;
				}
				if (!this.cover) {
					this.coverTip = true;
					return false;
				} else {
					this.coverTip = false;
				}
				if (!this.content) {
					this.contentTip = true;
					return false;
				} else {
					this.contentTip = false;
				}
				this.add();
			},
			// 新增
			add() {
				const that = this;
				that.loading = true;
				let requestData = {
					knowledgeType: that.type,
					catId: that.sort,
					orderNo: that.order,
					knowledgeTitle: that.title,
					knowledgeCont: that.content,
					coverImg: that.cover
				};
				Api.addIAssistantKnowledge(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取所有分类
			getSortList() {
				this.loading = true;
				Api.findIAssistantSort().then((res) => {
					if (res.data.success) {
						this.loading = false;
						let list = [];
						res.data.data.forEach(v => {
							list.push({
								id: v.id,
								label: v.catName
							});
						});
						this.sortList = list;
					} else {
						this.loading = false;
						this.$message.error(res.data.message);
					}
				}, (e) => {
					this.loading = false;
					this.$message.error(e.message);
				});
			},
			// 上传图片
			handleCoverUpload(e) {
				const that = this;
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadCover(base64[0], imgs_type[0], imgs_name[0]);
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的图片
			handleCoverDelete() {
				this.cover = '';
			},
			// 上传图片
			uploadCover(base64, img_type, fileName) {
				const that = this;
				that.loading = true;
				let postName = `${ new Date().getTime() }_${ fileName }`;
				let requestData = {
					base: base64,
					picName: postName,
					type: 'uGateWayUrl'
				};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.cover = res.data.data.imgUrl.split('?')[0];
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.loading = false;
					this.sortList = [];
					this.order = 1;
					this.type = 1;
					this.sort = '';
					this.title = '';
					this.cover = '';
					this.content = '';
					this.orderTip = false;
					this.sortTip = false;
					this.titleTip = false;
					this.coverTip = false;
					this.contentTip = false;
					this.getSortList();
				}
			}
		}
	}
</script>

<style>
</style>
